import React, { createContext, useCallback, useContext, useState } from 'react';
import NoteRatingModal from '../components/NoteRatingModal';

type PendingRating = {
  noteId: string;
  title: string;
};

type RatingPromptContextType = {
  openRatingPrompt: (payload: PendingRating) => void;
  clearRatingPrompt: () => void;
};

const RatingPromptContext = createContext<RatingPromptContextType | undefined>(undefined);

export function RatingPromptProvider({ children }: { children: React.ReactNode }) {
  const [pending, setPending] = useState<PendingRating | null>(null);

  const openRatingPrompt = useCallback((payload: PendingRating) => {
    setPending(payload);
  }, []);

  const clearRatingPrompt = useCallback(() => {
    setPending(null);
  }, []);

  return (
    <RatingPromptContext.Provider value={{ openRatingPrompt, clearRatingPrompt }}>
      {children}
      {pending && (
        <NoteRatingModal
          noteId={pending.noteId}
          noteTitle={pending.title}
          onClose={clearRatingPrompt}
        />
      )}
    </RatingPromptContext.Provider>
  );
}

export function useRatingPrompt() {
  const ctx = useContext(RatingPromptContext);
  if (!ctx) {
    throw new Error('useRatingPrompt must be used within RatingPromptProvider');
  }
  return ctx;
}
